import { Pressable, View } from 'react-native';
import { IconProps } from '../../Icons/Icons.types';
import { cn } from '../../lib/utils';
import { Text } from '../Text/Text';

export type RadioButtonSize = 'small' | 'large';
export type RadioButtonTextWeight = 'normal' | 'bold';

export const RadioButton = ({
  onPress,
  className,
  title,
  size = 'small',
  weight = 'bold',
  disabled = false,
  selected = false,
  textClassName,
  iconComponent: IconComponent,
  iconProps,
  iconClassname
}: {
  onPress?: () => void;
  className?: string;
  textClassName?: string;
  title: string;
  size?: RadioButtonSize;
  weight?: RadioButtonTextWeight;
  disabled?: boolean;
  selected?: boolean;
  iconComponent?: React.ElementType;
  iconProps?: IconProps;
  iconClassname?: string;
}) => {
  const backgroundColor = selected ? 'bg-primary' : 'bg-neutral-600';
  const textColor = disabled ? 'text-[#293D7A]' : 'text-white';
  const height = size == 'small' ? 'h-8' : 'h-10';
  const hoverActiveStyles =
    !disabled && !selected
      ? 'hover:bg-primary hover:bg-opacity-20 active:bg-primary'
      : '';

  return (
    <Pressable
      onPress={onPress}
      disabled={disabled}
      className={cn(
        'flex flex-row justify-center items-center bg-neutral-600 rounded-[30px]',
        height,
        backgroundColor,
        hoverActiveStyles,
        className,
      )}>
        
      {IconComponent &&
        <View className={iconClassname}>
          <IconComponent {...iconProps} />
        </View>
      }

      <Text
        style={{
          fontSize: 14,
          fontWeight: weight === 'bold' ? '600' : '400',
          lineHeight: 17,
        }}
        className={cn(textColor, textClassName)}>
        {title}
      </Text>
    </Pressable>
  );
};
